import Exchange from '~/components/Exchange'
import i18n from '~/i18n'
import { HOST } from '~/constants/host'

export const getServerSideProps = async () => {
  const t = i18n.t

  return {
    props: {
      openGraphData: [
        {
          property: 'og:url',
          content: `${HOST}/instant`,
          key: 'ogurl',
        },
        {
          property: 'og:title',
          content: t('meta_exchange_title'),
          key: 'ogtitle',
        },
        {
          property: 'og:description',
          content: t('meta_exchange_description'),
          key: 'ogdesc',
        },
      ],
    },
  }
}

export default Exchange
